import { configEnum } from '../enums/fetchFactoryEnum'
import fetchFactory from '../utils/fetchFactory'


const suggestEmail = (datasuggestEmail: string) => {
	if (datasuggestEmail.length >= 3) {
		return fetchFactory(`/api/dqe/suggestEmail?email=${encodeURIComponent(datasuggestEmail)}`, { method: configEnum.get })
	}
	return []
}

export default suggestEmail
